import { publicReferences, publicSourceChecked } from './scenario-research-reference';
export function ScenarioLocalSopReference({ onSource }: { readonly onSource: () => void }) {
  return (
    <section className="scc-panel scc-study">
      <header>
        <h2>
          本地 SOP 与适用性 <span>Local SOP & Governance</span>
        </h2>
        <p>机构正式程序、场景知识与平台运行纪律分别由各自 Owner 管理。</p>
      </header>
      <div className="scc-panel-body">
        <div className="scc-template-options">
          <article className="scc-study-card">
            <span className="scc-chip">Scenario 研究知识</span>
            <h3>研究风险与所需能力</h3>
            <p>风险、情报需求、能力与机器研究，不直接产生当地作业授权。</p>
          </article>
          <article className="scc-study-card">
            <span className="scc-chip scc-warn">Local Fire Service SOP</span>
            <h3>当地消防正式作业程序</h3>
            <p>由合法消防机构制定、批准并验证辖区适用性；当前未提供。</p>
          </article>
          <article className="scc-study-card">
            <span className="scc-chip scc-purple">Mission Runtime Policy</span>
            <h3>运行策略与 Human Authorization</h3>
            <p>权限、决策、审批、事件及审计由 Backend / 运行 / Policy Owner 拥有。</p>
          </article>
        </div>
        <div className="scc-notice" data-read-status="HOLD">
          LocalScenarioProfile：HOLD-AS-EXPLICIT-UNKNOWN。尚无 verified local
          mandate，不存在已生效的本地消防 SOP。
        </div>
        <h2>境外研究与制度参考</h2>
        <p>
          参考资料，不等于本地区 SOP。公开页面核对 {publicSourceChecked}
          ；本地适用性与消防环境验证未提供。
        </p>
        {publicReferences
          .filter((item) =>
            ['NIST-WIND', 'NIST-PPV', 'NIST-CREW', 'OSHA', 'NIMS'].includes(item.id),
          )
          .map((item, index) => (
            <article className="scc-sop-reference" key={item.id}>
              <span>{index + 1}</span>
              <div>
                <h3>{item.name}</h3>
                <p>{item.type} · EXTERNAL_PUBLIC_RESEARCH</p>
                <a href={item.url} target="_blank" rel="noopener noreferrer">
                  查看原始资料 ↗
                </a>
              </div>
            </article>
          ))}
        <h3>正式本地化还缺什么？</h3>
        <ul>
          <li>适用国家、辖区与合法消防机构</li>
          <li>法规授权 / mandate 与正式 SOP 文件、适用版本</li>
          <li>审批、更新与维护责任</li>
          <li>与所选模板的受控验证关系</li>
        </ul>
        <button onClick={onSource}>查看本地适用性与来源缺口 →</button>
      </div>
    </section>
  );
}
